export enum ShippingStatus {
  pending,
  sent,
  received,
  return_sent,
  return_received,
}
